var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"top-bar-title":_vm.title,"sections":_vm.sections,"baseLayoutInfoUrl":'/base-layout-info/'}},[_c('AgreementsTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }